$(document).ready(function() {
    const $selectWrap = $(".js-select-wrap");
    const $selectBtn = $(".js-select-btn");
    const $selectOption = $(".js-select-dropdown button");


    $($selectBtn).each((index, element) => {

        $(element).on("click", () => {
            let currentSelectWrap = $(element).parent();

            if (currentSelectWrap.length) {

                let isOpen = currentSelectWrap.hasClass("open");

                $($selectWrap).each((index, element) => {
                    $(element).removeClass("open");
                });

                if (isOpen) {
                    currentSelectWrap.removeClass("open");
                } else {
                    currentSelectWrap.addClass("open");
                }
            }
        });
    });

    $($selectOption).each((index, element) => {

        let val = $(element).data("value");
        let text = $(element).text();

        let currentSelectWrap = $(element).closest(".js-select-wrap");
        let currentSelectBtn = currentSelectWrap.children(".js-select-btn");
        if (currentSelectWrap.length) {
            $(element).on("click", () => {

                $(currentSelectBtn).text(text);
                $(currentSelectBtn).attr("data-value", val);
                $(currentSelectWrap).toggleClass("open");
                $(currentSelectWrap).find("input").val(val);
            });
        }

    });
});
